export default {
  computed: {
    is_expanded() {
      return this.$store.state.sidebar_is_expanded;
    },
  },
};
